// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.T65OcVUhYo3jHJ41CyI5 {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
}

.m36U7UaLg5EXh_mBptkD {
  margin-bottom: 0;
}

.XNMwsmkXxOUen0XmpYSR {
  display: flex;
  flex: 1;
}

.tqvozkyIUcG3LOiEUlrq {
  align-items: center;
  display: flex;
  justify-content: flex-end;
}

.tqvozkyIUcG3LOiEUlrq > .HMPtq6U3hs91OZvt9l93 + .HMPtq6U3hs91OZvt9l93 {
  margin-left: 16px;
}


.ylU2xymT5kJYbLxWo3sd{
  display: flex;
  flex: 1;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
}

.cMADdPwEJg9dwl1xpKHj{
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.5;
  text-align: left;
}

.pb2m7NDjyaIpRSYZTedg {
  display: none;
  font-size: 10px;
  padding-left: 5px;
  padding-bottom: 10px;
  position: absolute;
  left: 10px;
  right: 0;
  bottom: 5px;
  top: -5px;
}

.Qkh8p_fn3K9MmXe8SHrt {
  position: relative;
}

.aLKA9xRbXWVp8_1gN8KM{
  display: flex;
  align-items: center;
}

.Qkh8p_fn3K9MmXe8SHrt:hover .pb2m7NDjyaIpRSYZTedg {
  display: inline-block;
}



._wUukCB2ske527hngEKN, ._wUukCB2ske527hngEKN tr, ._wUukCB2ske527hngEKN th {
  margin: 0;
  padding: 0;
  border: 0;
  vertical-align: middle;
}

._wUukCB2ske527hngEKN td{
  padding-right: 5px;
  padding-left: 5px;
}

._wUukCB2ske527hngEKN {
  width: 100%;
  background-color: transparent;
  border-collapse: collapse;
  border-spacing: 0;
}

/* Heading */

._wUukCB2ske527hngEKN th {
  padding: 11px 15px 15px 0;
  font-size: 14px;
  font-weight: 600;
  color: hc-secondary;
  text-transform: uppercase;
  user-select: none;

}

._wUukCB2ske527hngEKN .bbQbPXfQhsVx4uJabSxz {
  position: relative;
}

._wUukCB2ske527hngEKN .bbQbPXfQhsVx4uJabSxz i {
  position: absolute;
  top: -1px;
  left: 3px;
}

._wUukCB2ske527hngEKN .H4tIWppbfxFBJsGSXzZT {
  position: relative;
}

._wUukCB2ske527hngEKN .H4tIWppbfxFBJsGSXzZT i {
  position: absolute;
  top: 6px;
  left: 3px;
}

.QIDfnXfdS8BB23zf2uMJ {
  margin-right: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/template-groups/template-table.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;EACE,aAAa;EACb,OAAO;EACP,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;;;AAIA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,YAAY;;AAEZ;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;;AAEnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".header {\n  align-items: flex-start;\n  display: flex;\n  justify-content: space-between;\n}\n\n.title {\n  margin-bottom: 0;\n}\n\n.container {\n  display: flex;\n  flex: 1;\n}\n\n.buttons {\n  align-items: center;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.buttons > .button + .button {\n  margin-left: 16px;\n}\n\n\n.approvalModalContainer{\n  display: flex;\n  flex: 1;\n  justify-content: space-around;\n  align-items: center;\n  flex-direction: column;\n}\n\n.modalText{\n  text-align: center;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 1.5;\n  text-align: left;\n}\n\n.deleteTextContainer {\n  display: none;\n  font-size: 10px;\n  padding-left: 5px;\n  padding-bottom: 10px;\n  position: absolute;\n  left: 10px;\n  right: 0;\n  bottom: 5px;\n  top: -5px;\n}\n\n.deleteContainer {\n  position: relative;\n}\n\n.dle{\n  display: flex;\n  align-items: center;\n}\n\n.deleteContainer:hover .deleteTextContainer {\n  display: inline-block;\n}\n\n\n\n.table, .table tr, .table th {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  vertical-align: middle;\n}\n\n.table td{\n  padding-right: 5px;\n  padding-left: 5px;\n}\n\n.table {\n  width: 100%;\n  background-color: transparent;\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n/* Heading */\n\n.table th {\n  padding: 11px 15px 15px 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: hc-secondary;\n  text-transform: uppercase;\n  user-select: none;\n\n}\n\n.table .headingCellDesc {\n  position: relative;\n}\n\n.table .headingCellDesc i {\n  position: absolute;\n  top: -1px;\n  left: 3px;\n}\n\n.table .headingCellAsc {\n  position: relative;\n}\n\n.table .headingCellAsc i {\n  position: absolute;\n  top: 6px;\n  left: 3px;\n}\n\n.accessTypeIcon {\n  margin-right: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `T65OcVUhYo3jHJ41CyI5`,
	"title": `m36U7UaLg5EXh_mBptkD`,
	"container": `XNMwsmkXxOUen0XmpYSR`,
	"buttons": `tqvozkyIUcG3LOiEUlrq`,
	"button": `HMPtq6U3hs91OZvt9l93`,
	"approvalModalContainer": `ylU2xymT5kJYbLxWo3sd`,
	"modalText": `cMADdPwEJg9dwl1xpKHj`,
	"deleteTextContainer": `pb2m7NDjyaIpRSYZTedg`,
	"deleteContainer": `Qkh8p_fn3K9MmXe8SHrt`,
	"dle": `aLKA9xRbXWVp8_1gN8KM`,
	"table": `_wUukCB2ske527hngEKN`,
	"headingCellDesc": `bbQbPXfQhsVx4uJabSxz`,
	"headingCellAsc": `H4tIWppbfxFBJsGSXzZT`,
	"accessTypeIcon": `QIDfnXfdS8BB23zf2uMJ`
};
export default ___CSS_LOADER_EXPORT___;
